export const T_PREFIX = "form-field";

export const formFieldTrns = {
  email: `${T_PREFIX}.email`,
  phoneNumber: `${T_PREFIX}.phone-number`,
  password: `${T_PREFIX}.password`,
  country: `${T_PREFIX}.country`,
  countries: `${T_PREFIX}.countries`,
  companyName: `${T_PREFIX}.company-name`,
  legalAddress: `${T_PREFIX}.legal-address`,
  websiteLink: `${T_PREFIX}.website-link`,
  firstName: `${T_PREFIX}.first-name`,
  lastName: `${T_PREFIX}.last-name`,
  industry: `${T_PREFIX}.industry`,
  description: `${T_PREFIX}.description`,
  min: `${T_PREFIX}.min`,
  max: `${T_PREFIX}.max`,
  companyPresentation: `${T_PREFIX}.company-presentation`,
  companyPresentationPlaceholder: `${T_PREFIX}.company-presentation-placeholder`,
  googleBusinessProfileLink: `${T_PREFIX}.google-business-profile-link`,
  describeYourProduct: `${T_PREFIX}.describe-your-product`,
  mainAdvantages: `${T_PREFIX}.main-advantages`,
  amountOfNecessaryInvestment: `${T_PREFIX}.amount-of-necessary-investment`,
  howLongOnMarket: `${T_PREFIX}.how-long-on-market`,
  numberOfCustomers: `${T_PREFIX}.number-of-customers`,
  numberOfEmployees: `${T_PREFIX}.number-of-employees`,
  annualTurnoverOfCompany: `${T_PREFIX}.annual-turnover-of-company`,
  monthlyIncomeOfCompany: `${T_PREFIX}.monthly-income-of-company`,
  readyToParticipateOfCloneCapital: `${T_PREFIX}.ready-to-participate-of-clone-capital`,
  readyToParticipateOfCloneCapitalDesc: `${T_PREFIX}.ready-to-participate-of-clone-capital-description`,
  ownsRightsToPatents: `${T_PREFIX}.owns-rights-to-patents`,
  costOfClone: `${T_PREFIX}.cost-of-clone`,
  companysActivities: `${T_PREFIX}.companys-activities`,
  companysClients: `${T_PREFIX}.companys-clients`,
  timeCompanyWillSupportBuyer: `${T_PREFIX}.time-company-will-support-buyer`,
  informationSoldInCloneForm: `${T_PREFIX}.information-sold-in-clone-form`,
  accessToProductionAndInvolvementBuyersRepresentative: `${T_PREFIX}.access-to-production-and-involvement-buyers-representative`,
  companyBranding: `${T_PREFIX}.company-branding`,
  prohibitedCountries: `${T_PREFIX}.prohibited-countries`,
  additionalInformation: `${T_PREFIX}.additional-information`,
  newPassword: `${T_PREFIX}.new-password`,
  repeatNewPassword: `${T_PREFIX}.repeat-new-password`,
  yourName: `${T_PREFIX}.your-name`,
  yourEmail: `${T_PREFIX}.your-email`,
  yourPhone: `${T_PREFIX}.your-phone`,
  yourCountry: `${T_PREFIX}.your-country`,
  iAm: `${T_PREFIX}.i-am`,
  howWeCanHelp: `${T_PREFIX}.how-we-can-help`,

  maxPlaceholder: `${T_PREFIX}.max.placeholder`,
  minPlaceholder: `${T_PREFIX}.min.placeholder`,
};
